module.exports = __webpack_public_path__ + "img/playicon.d765f618.svg";